import { render, staticRenderFns } from "./CartoonFan.vue?vue&type=template&id=67c94c27&scoped=true&"
import script from "./CartoonFan.vue?vue&type=script&lang=js&"
export * from "./CartoonFan.vue?vue&type=script&lang=js&"
import style0 from "./CartoonFan.vue?vue&type=style&index=0&id=67c94c27&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c94c27",
  null
  
)

export default component.exports